import { z } from "zod";
import { ZObjectIdString } from "../../../schemas/accessControlSchema.js";
import { ZBaseComment } from "../../../schemas/commentSchema.js";

export const OVERLEVERING_CHECKLIST_TYPES = {
  OVERLEVERING: "startup_checklist_overlevering",
} as const;

export const ZOverleveringChecklistType = z.enum([OVERLEVERING_CHECKLIST_TYPES.OVERLEVERING]);

export const ZOverleveringChecklistAnswer = z.enum(["JA", "NEI", "IR", "UAVKLART"]);

export const ZOverleveringChecklistAnswerChange = z.object({
  _id: ZObjectIdString,
  from: ZOverleveringChecklistAnswer.nullable(),
  to: ZOverleveringChecklistAnswer.nullable(),
  changedBy: z.object({ _id: ZObjectIdString, name: z.string() }),
  changedAt: z.string().datetime(),
});

export const ZOverleveringChecklistSectionRow = z.object({
  nr: z.string(),
  text: z.string(),
  kind: z.literal("SECTION"),
});

export const ZOverleveringChecklistQuestionRow = z.object({
  questionId: z.string().trim().min(1),
  nr: z.string(),
  text: z.string(),
  kind: z.literal("QUESTION"),
  answer: ZOverleveringChecklistAnswer.nullable(),
  answerUpdatedBy: z.object({ _id: ZObjectIdString, name: z.string() }).nullish(),
  answerUpdatedAt: z.string().datetime().nullish(),
  answerHistory: ZOverleveringChecklistAnswerChange.array().default([]),
  comments: ZBaseComment.array().default([]),
});

export const ZOverleveringChecklistRow = z.discriminatedUnion("kind", [
  ZOverleveringChecklistSectionRow,
  ZOverleveringChecklistQuestionRow,
]);

export const ZOverleveringChecklistReport = z.object({
  overleveringChecklistType: ZOverleveringChecklistType,
  rows: z.array(ZOverleveringChecklistRow),
});

export type IOverleveringChecklistAnswer = z.infer<typeof ZOverleveringChecklistAnswer>;
export type IOverleveringChecklistSectionRow = z.infer<typeof ZOverleveringChecklistSectionRow>;
export type IOverleveringChecklistQuestionRow = z.infer<typeof ZOverleveringChecklistQuestionRow>;
export type IOverleveringChecklistRow = z.infer<typeof ZOverleveringChecklistRow>;
export type IOverleveringChecklistReport = z.infer<typeof ZOverleveringChecklistReport>;
export type IOverleveringChecklistType = z.infer<typeof ZOverleveringChecklistType>;

export type OverleveringChecklistRowDef =
  | {
      nr: string;
      text: string;
      kind: "SECTION";
    }
  | {
      nr: string;
      text: string;
      kind: "QUESTION";
      questionId: string;
    };
